import Immutable from 'immutable'
import { handleActions, combineActions } from 'redux-actions'
import { RESET_STORE } from 'constants/index'

export const LOGIN = 'auth/LOGIN'
export const LOGIN_GOOGLE = 'auth/LOGIN_GOOGLE'
export const LOGIN_MICROSOFT = 'auth/LOGIN_MICROSOFT'
export const [LOGIN_SUCCESS, LOGIN_FAILURE] = [
  `${LOGIN}_SUCCESS`,
  `${LOGIN}_FAILURE`,
]

export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD'
export const [FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE] = [
  `${FORGOT_PASSWORD}_SUCCESS`,
  `${FORGOT_PASSWORD}_FAILURE`,
]

export const RECOVERY_PASSWORD = 'auth/RECOVERY_PASSWORD'
export const [RECOVERY_PASSWORD_SUCCESS, RECOVERY_PASSWORD_FAILURE] = [
  `${RECOVERY_PASSWORD}_SUCCESS`,
  `${RECOVERY_PASSWORD}_FAILURE`,
]

export const RESET_TOKEN_EXIST = 'auth/RESET_TOKEN_EXIST'
export const [RESET_TOKEN_EXIST_SUCCESS, RESET_TOKEN_EXIST_FAILURE] = [
  `${RESET_TOKEN_EXIST}_SUCCESS`,
  `${RESET_TOKEN_EXIST}_FAILURE`,
]

const initialState = Immutable.fromJS({
  loading: false,
  exist: true,
})

export const login = (data, promise) => ({
  promise,
  payload: data,
  type: LOGIN,
})

export const loginWithGoogle = (data, promise) => ({
  promise,
  payload: data,
  type: LOGIN_GOOGLE,
})

export const loginWithMicrosoft = (data, promise) => ({
  promise,
  payload: data,
  type: LOGIN_MICROSOFT,
})

export const forgotPassword = (data, promise) => ({
  promise,
  payload: data,
  type: FORGOT_PASSWORD,
})

export const recoveryPassword = (data, promise) => ({
  promise,
  payload: data,
  type: RECOVERY_PASSWORD,
})

export const resetTokenExist = data => ({
  payload: data,
  type: RESET_TOKEN_EXIST,
})

export default handleActions(
  {
    [combineActions(LOGIN, RECOVERY_PASSWORD, FORGOT_PASSWORD)]: state =>
      state.set('loading', true),
    [combineActions(
      LOGIN_FAILURE,
      RECOVERY_PASSWORD_FAILURE,
      FORGOT_PASSWORD_FAILURE,
      RECOVERY_PASSWORD_SUCCESS,
      FORGOT_PASSWORD_SUCCESS,
    )]: state => state.set('loading', false),
    [LOGIN_SUCCESS]: state => state.set('isAuth', true).set('loading', false),
    [RESET_TOKEN_EXIST_SUCCESS]: state => state.set('exist', true),
    [RESET_TOKEN_EXIST_FAILURE]: state => state.set('exist', false),
    [RESET_STORE]: () => initialState,
  },
  initialState,
)
